import React from 'react';

function MinusIcon({ className = '' }) {
	return (
		<svg
			className={className}
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clipPath='url(#clip0_3504_6014)'>
				<path d='M19 13H5V11H19V13Z' fill='#323232' />
			</g>
			<defs>
				<clipPath id='clip0_3504_6014'>
					<rect width='24' height='24' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
}

export default MinusIcon;
